import { initPhpLayoutTermsOfServicePopup } from './phpLayoutTermsOfServicePopup';

initPhpLayoutTermsOfServicePopup();
